import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import FastingTimer from '../../components/fasting/FastingTimer';
import { motion } from 'framer-motion';

const FastingScreen = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" fontWeight={700} gutterBottom>
                    Ayuno Intermitente
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                    Gestiona tus ventanas de alimentación y descanso digestivo
                </Typography>
            </Box>

            <Grid container spacing={4}>
                <Grid item xs={12} md={6} lg={5}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <FastingTimer />
                    </motion.div>
                </Grid>

                <Grid item xs={12} md={6} lg={7}>
                    {/* Placeholder for stats/history */}
                    <Box sx={{ p: 3, bgcolor: 'background.paper', borderRadius: 4, height: '100%' }}>
                        <Typography variant="h6" gutterBottom>
                            Beneficios Activos
                        </Typography>
                        <Typography variant="body2" paragraph>
                            El ayuno intermitente permite que tu cuerpo descanse de la digestión y active procesos de reparación celular como la autofagia.
                        </Typography>
                        {/* More content can be added here */}
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default FastingScreen;
